import React from "react";
import Modal from "react-bootstrap/Modal";
import MarkOnHold from "../components/MarkOnHold";

const PlaceOnHoldModal = ({ visible, close, user, updateUser }) => {
  return (
    <Modal
      show={visible}
      onHide={close}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={"text-capitalize"}
        >
          <h1 className={"text-axis-offblack icon-text-wrapper"}>
            Place User on hold
          </h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <MarkOnHold
          user={user}
          onComplete={(u) => {
            updateUser(u);
            close();
          }}
          close={close}
        />
      </Modal.Body>
    </Modal>
  );
};

export default PlaceOnHoldModal;
